import { useEffect } from 'react';

import { useMatches } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

interface MetaTag {
    name?: string;
    content?: string;
    params?: Record<string, string>;
}

export function useMetaTags() {
    const { t } = useTranslation();
    const matches = useMatches();
    useEffect(() => {
        const updateMetaTags = () => {
            let metaTags: MetaTag[] = [];
            let currentRouteIndex = matches.length - 1;

            while (currentRouteIndex >= 0 && metaTags.length === 0) {
                const currentRoute = matches[currentRouteIndex];
                metaTags = 'meta' in currentRoute.context ? currentRoute.context.meta : [];
                currentRouteIndex--;
            }

            if (metaTags.length === 0) {
                return;
            }

            document.querySelectorAll('meta[name]').forEach((meta) => meta.remove());
            document.title = 'C-Pool';

            metaTags.forEach(({ content, name, params }) => {
                // @ts-expect-error -- typescript cannot recognize this dynamic string
                const translatedContent = (content ? t(content, params) : '') as string;
                if (name === 'title') {
                    document.title = translatedContent;
                } else {
                    const meta = document.createElement('meta');
                    meta.name = name || '';
                    meta.content = translatedContent;
                    document.head.appendChild(meta);
                }
            });
        };

        updateMetaTags();
    }, [matches, t]);
}
